const pedalConfig = {
    "enclosure": {
        "width": 58.5,
        "depth": 107,
        "height": 31,
        "cornerRadius": 3,
        "bevelSize": 1.4,
        "bevelSegments": 4
    },
    "bodyMaterial": {
        "color": "#bdc0c2",
        "metalness": 1,
        "roughness": 0.34
    },
    "printableArea": {
        "width": 60,
        "depth": 108
    },
    "screenprint": {
        "texturePath": "textures/austerev2.png",
        "opacity": 0.95
    },
    "knobLayout": {
        "holeDiameter": 7,
        "radius": 7,
        "height": 13,
        "topRoundness": 1.2,
        "color": "#1f2127",
        "roughness": 0.58,
        "stripeColor": "#f7f7f7",
        "stripeWidth": 0.8,
        "stripeDepth": 0.25,
        "stripeDrop": 10.8,
        "rows": [
            {
                "id": "top",
                "count": 3,
                "y": 44,
                "spacing": 17
            },
            {
                "id": "second",
                "count": 0,
                "y": 12,
                "spacing": 18
            }
        ]
    },
    "holes": [
        {
            "id": "led1",
            "type": "led",
            "x": -17,
            "y": -28,
            "diameter": 5
        },
        {
            "id": "led2",
            "type": "led",
            "x": 17,
            "y": -28,
            "diameter": 5
        },
        {
            "id": "fs1",
            "type": "footswitch",
            "x": -17,
            "y": -40,
            "diameter": 12
        },
        {
            "id": "fs2",
            "type": "footswitch",
            "x": 17,
            "y": -40,
            "diameter": 12
        }
    ],
    "leds": [
        {
            "id": "left",
            "holeId": "led1",
            "radius": 2.3,
            "height": 3,
            "color": "#ff2a2a",
            "intensity": 2.1
        },
        {
            "id": "right",
            "holeId": "led2",
            "radius": 2.3,
            "height": 3,
            "color": "#ff2a2a",
            "intensity": 2.1
        }
    ],
    "footswitches": [
        {
            "id": "left",
            "holeId": "fs1",
            "radius": 6,
            "shaftRadius": 3.4,
            "topSectionHeight": 3.6,
            "height": 10,
            "color": "#d9dbde",
            "roughness": 0.24
        },
        {
            "id": "right",
            "holeId": "fs2",
            "radius": 6,
            "shaftRadius": 3.4,
            "topSectionHeight": 3.6,
            "height": 10,
            "color": "#d9dbde",
            "roughness": 0.24
        }
    ],
    "toggleSwitches": [
        {
            "id": "mode-a",
            "x": -18,
            "y": -4,
            "holeDiameter": 6,
            "bushingRadius": 3.4,
            "bushingHeight": 2,
            "leverRadius": 0.9,
            "leverHeight": 8,
            "position": "bottom"
        },
        {
            "id": "mode-b",
            "x": 0,
            "y": -4,
            "holeDiameter": 6,
            "bushingRadius": 3.4,
            "bushingHeight": 2,
            "leverRadius": 0.9,
            "leverHeight": 8,
            "position": "middle"
        },
        {
            "id": "mode-c",
            "x": 18,
            "y": -4,
            "holeDiameter": 6,
            "bushingRadius": 3.4,
            "bushingHeight": 2,
            "leverRadius": 0.9,
            "leverHeight": 8,
            "position": "top"
        }
    ],
    "backScrews": {
        "inset": 2,
        "headRadius": 2.8,
        "headHeight": 1.8,
        "slotWidth": 0.8,
        "slotDepth": 0.25,
        "slotLength": 4.2,
        "color": "#c9ccd0"
    },
    "topSideJacks": {
        "quarterInch": {
            "count": 2,
            "edgeInset": 14,
            "zOffsetFromTop": 15,
            "diameter": 9.5,
            "recessDepth": 4,
            "ringDiameter": 12,
            "ringDepth": 1.6
        },
        "power9v": {
            "diameter": 11,
            "recessDepth": 4.5,
            "ringDiameter": 14,
            "ringDepth": 1.8,
            "zOffsetFromTop": 15
        }
    },
    "threading": {
        "ridgeCount": 10,
        "ridgeDepth": 0.2,
        "ridgeThickness": 0.12,
        "contrast": 0.55,
        "nutContrast": 0.22,
        "threadLengthScale": 1.15,
        "nutThicknessScale": 1,
        "threadPeek": 0.7
    },
    "debug": {
        "showJackCutters": false
    }
};
export default pedalConfig;
